import { LitElement, html } from 'lit'
import './hero-section.js'
import './features-section.js'
import './testimonials-section.js'
import './about-section.js'
import './cta-section.js'
import './site-footer.js'
import './theme-toggle.js'

class JigsaiApp extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    render() {
        return html`
            <div class="relative">
                <!-- Theme Toggle -->
                <div class="fixed top-4 right-4 z-50 flex justify-end">
                    <theme-toggle></theme-toggle>
                </div>
                
                <!-- Hero Section -->
                <hero-section></hero-section>
                
                <!-- Features Section -->
                <features-section></features-section>
                
                <!-- About Section -->
                <about-section></about-section>
                
                <!-- Testimonials Section -->
                <testimonials-section></testimonials-section>
                
                <!-- CTA Section -->
                <cta-section></cta-section>
                
                <!-- Footer -->
                <site-footer></site-footer>
            </div>
        `
    }
}

customElements.define('jigsai-app', JigsaiApp)